import { MediaPlayerClass } from "dashjs";
import { createContext } from "react";

export const MediaPlayerContext = createContext<MediaPlayerClass | null>(null);
